export default __webpack_public_path__ + "static/media/nenesan_icon.e438a424.png";